import { http, bookingApi } from 'services/http';
import { sortArrayFromTag } from 'services/functions';
import * as commonTypes from './commonActionTypes';
import { localAppointmentsFilters } from '../services/appointments';

export const setBackUrl = (params) => ({
  type: commonTypes.SET_BACK_URL,
  payload: { url: window.location.pathname, params }
});

export const resetBackUrl = () => ({ type: commonTypes.RESET_BACK_URL, });

//──── Campuses ──────────────────────────────────────────────────────────────────────────
export const loadAndSaveCampusesList = () => dispatch => {
  bookingApi
    .get('campuses', { withoutLoader: true, withoutRedux: true })
    .then(({ data }) => {
      dispatch(saveCampusesList(data));
      // if have stored campus id
      const keyName = 'campusId';
      const locCampusId = localAppointmentsFilters.get(keyName);
      if (locCampusId) {
        dispatch(updateCommonFilters({ [keyName]: locCampusId }));
      }
    })
    .catch(() => {
      dispatch(errorLoadCampusesList());
    });
};

const saveCampusesList = list => ({
  type: commonTypes.SET_CAMPUSES_LIST,
  payload: list
});

const errorLoadCampusesList = () => ({
  type: commonTypes.ERROR_LOAD_CAMPUSES_LIST
});

//──── Filters ───────────────────────────────────────────────────────────────────────────
export const updateCommonFilters = dataObj => {
  localAppointmentsFilters.set(dataObj);
  return {
    type: commonTypes.UPDATE_COMMON_FILTERS,
    payload: dataObj
  };
};

//──── Practitioners ─────────────────────────────────────────────────────────────────────
export const loadAndSavePractitionersList = () => (dispatch, getState) => {
  http
    .get('practitioners', { withoutLoader: true, withoutRedux: true })
    .then(({ data }) => {
      if (data && Array.isArray(data)) {
        const onlyActivePractitioner = data.filter(doc => doc.isActive);
        const state = getState();
        const {
          auth,
          practitioner: {
            common: {
              commonFilters: { practitionerId }
            }
          }
        } = state;
        dispatch(savePractitionersList(sortArrayFromTag(onlyActivePractitioner, 'lastName')));
        const keyName = 'practitionerId';
        const locDoctorId = localAppointmentsFilters.get(keyName);
        let initPractitionerId;
        if (locDoctorId && onlyActivePractitioner.some(pr => pr.id === locDoctorId)) {
          // if have stored practitioner
          initPractitionerId = locDoctorId;
        } else if (practitionerId && onlyActivePractitioner.some(pr => pr.id === practitionerId)) {
          // if practitioner already installed
          initPractitionerId = practitionerId;
        } else if (
          auth &&
          auth.practitioner &&
          auth.practitioner.nameIdentifier &&
          onlyActivePractitioner.some(pr => pr.id === auth.practitioner.nameIdentifier)
        ) {
          // if doctor login
          initPractitionerId = auth.practitioner.nameIdentifier;
        } else {
          // if unknown user login (staff)
          initPractitionerId = onlyActivePractitioner[0].id;
        }
        dispatch(updateCommonFilters({ [keyName]: initPractitionerId }));
      }
    })
    .catch(() => {
      dispatch(errorLoadPractitionersList());
    });
};

const savePractitionersList = list => ({
  type: commonTypes.SET_PRACTITIONERS_LIST,
  payload: list
});

const errorLoadPractitionersList = () => ({
  type: commonTypes.ERROR_LOAD_PRACTITIONERS_LIST
});
